import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=becdc49e&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=becdc49e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becdc49e",
  null
  
)

export default component.exports